import qs from 'qs';
import { UsersCreateRequest, UsersGetResponse, UsersUpdateRequest, ProfileFilterRequest, ProfileFilterResponse } from '.';
import { PagedResult, useApi } from '..';
import { isValidGuid } from '@app/utils/guidHelpers';

export function useUsersService() {
  const { put, post, get, patch } = useApi();
  const baseApi = `/v2/users`;

  const setLanguage = async (request: { languageName: 'en' | 'pt-BR' | "es" | undefined}) => {
    const { data } = await put<{}>(`${baseApi}/language`, request);

    return data;
  };

  const createUser = async (user: UsersCreateRequest) => {
    const { data } = await post(`${baseApi}`, user);

    return data;
  };

  const updateUsers = async (users: UsersUpdateRequest[]) => {
    const { data } = await put(`${baseApi}`, users);

    return data;
  };

  const blockUser = async (requestData: { block: boolean }, id: number) => {
    const { data } = await patch(`${baseApi}/${id}`, requestData);

    return data;
  }

  const reinviteUser = async (userId: number) => {
    const { data } = await post(`${baseApi}/${userId}/invitations`);

    return data
  }

  const getUsers = async (
    filter?: string, 
    plants?: string[], 
    status?: string[], 
    roles?: string[],
    customers?: number[],
    size?: number, 
    page?: number, 
    sorting?: string
  ) => {
    const params = { 
      filter,
      plantId: plants, 
      customerId: customers, 
      userStatus: status, 
      role: roles, 
      sorting,
      size,
      page
    }

    const { data } = await get<PagedResult<UsersGetResponse>>(`${baseApi}`, {
      params,
      paramsSerializer(params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      },
    });

    return data;
  };

  const getAllowedProfiles = async (request: ProfileFilterRequest) => {
    const params: Record<string, string> = {
      email: request.email
    };

    // Only include plantId if it's valid (not empty and not undefined)
    if (isValidGuid(request.plantId)) {
      params.plantId = request.plantId!;
    }

    const { data } = await get<ProfileFilterResponse>(`${baseApi}/profiles/allowed`, {
      params,
      paramsSerializer(params) {
        return qs.stringify(params, { skipNulls: true });
      },
    });

    return data;
  };

  return {
    setLanguage,
    createUser,
    updateUsers,
    getUsers,
    blockUser,
    reinviteUser,
    getAllowedProfiles
  };
}
